import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <div class="heading01"><h2>{{ 'performanceReview.Employee information' | translate }}</h2></div>
        <div class="form">
            <form-wrapper form="vm.form">
                <div class="row">
                    <label class="label">{{ 'performanceReview.Name' | translate }}</label>
                    <div class="items">
                        <span class="text">{{ vm.review.user.displayName }}</span>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'performanceReview.Role' | translate }}</label>
                    <div class="items">
                        <span class="text">{{ vm.review.roles }}</span>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'performanceReview.Department' | translate }}</label>
                    <div class="items">
                        <span class="text">{{ vm.review.departments }}</span>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'performanceReview.Direct manager' | translate }}</label>
                    <div class="items">
                        <span class="text">{{ vm.review.manager.displayName }}</span>
                    </div>
                </div>
            </form-wrapper>
        </div>
    `
})
export default class {
    constructor ($scope, ReviewResource, ReviewService, FormFactory, REVIEW_STATUS_ENUM) {
        this.$scope = $scope;
        this.ReviewResource = ReviewResource;
        this.ReviewService = ReviewService;
        this.FormFactory = FormFactory;
        this.REVIEW_STATUS_ENUM = REVIEW_STATUS_ENUM;
        $scope.$on('review:save', () => this.save());
    }

    $onInit () {
        if (this.review.isManageView) {
            this.form = this.FormFactory.create(
                this.review,
                model => this.ReviewResource.get(model.id).$promise
            );
            return;
        }

        const expand = this.ReviewService.getExpandString();
        this.form = this.FormFactory.create(
            this.review,
            model => this.ReviewResource.publicUpdate({ guid: model.guid, expand }, model).$promise
        );

        if (this.review.status === this.REVIEW_STATUS_ENUM.KEYS.NOT_STARTED && !this.review.isManager) {
            this.startReview();
        }
    }

    startReview () {
        this.review.status = this.REVIEW_STATUS_ENUM.KEYS.FILL_EMPLOYEE;
        this.ReviewResource.publicUpdate({
            guid: this.review.guid, expand: this.ReviewService.getExpandString()
        }, this.review).$promise.then(model => {
            this.$scope.$emit('review:reload', model);
            // manually set new form status
            this.form.model.status = model.status;
        });
    }

    save () {
        // if manager, skip submitting and continue with form
        if (this.review.isManager) {
            this.$scope.$emit('review:save:success');
        }
        else {
            this.form.save()
                .then((model) => {
                    this.$scope.$emit('review:save:success');
                    this.$scope.$emit('review:reload', model);
                })
                .catch(() => this.$scope.$emit('review:save:error'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/info/index.js